/*!
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 记者模块路由
 */

const ReporterList = () => import('@/views/reporter/list.vue')
const ReporterGroups = () => import('@/views/reporter/groups.vue')
const ReporterMergeLogs = () => import('@/views/reporter/mergeLogs.vue')
const ReporterGroupsList = () => import('@/views/reporter/groupsList.vue')
const ReporterCreate = () => import('@/views/reporter/create.vue')
const ReporterDetail = () => import('@/views/reporter/detail.vue')
const ReporterAddNews = () => import('@/views/reporter/addNews.vue')
const ReporterToDeleted = () => import('@/views/reporter/toDeletedList.vue')
const ReporterCollection = () => import('@/views/reporter/reporterCollection.vue')
const ReporterRank = () => import('@/views/reporter/reporterRank.vue')
const ReporterNews = () => import('@/views/reporter/reporterNews.vue')
const CollectionDetail = () => import('@/views/reporter/collectionDetail.vue')
const ReporterRecommend = () => import('@/views/reporter/toRecommend.vue')
/* Layout */
import Layout from '@/layout/index.vue'
/* Children Layout */
import ChildLayout from '@/layout/children_layout.vue'

export default {
    path: '/reporter',
    component: Layout,
    redirect: '/reporter/list',
    meta: {
        title: '记者',
        icon: 'icon-media',
        alwaysShow: true // will always show the root menu
    },
    children: [
        {
            path: 'rank',
            component: ReporterRank,
            name: 'ReporterRank',
            meta: {
                title: '记者榜单'
            }
        },
        {
            path: 'list',
            component: ReporterList,
            name: 'ReporterList',
            meta: {
                title: '记者列表'
            }
        },
        {
            path: '/collection',
            component: ChildLayout,
            children: [
                {
                    path: '/reporter/collection',
                    name: 'ReporterCollection',
                    component: ReporterCollection,
                    meta: {
                        title: '记者集合'
                    }
                },
                {
                    path: '/reporter/collection/:id',
                    component: CollectionDetail,
                    name: 'CollectionDetail',
                    meta: {
                        title: '集合详情',
                        hidden: true
                    }
                }
            ]
        },
        {
            path: '/recommend',
            name: 'ReporterRecommend',
            component: ReporterRecommend,
            meta: {
                title: '推荐记者',
                hidden: false
            }
        },
        {
            path: 'to-deleted',
            component: ReporterToDeleted,
            name: 'ReporterToDeleted',
            meta: {
                title: '待删除记者排查'
            }
        },
        {
            path: 'groups',
            component: ReporterGroups,
            name: 'ReporterGroups',
            meta: {
                title: '重复记者排查'
            }
        },
        {
            path: 'merge-logs',
            component: ReporterMergeLogs,
            name: 'ReporterMergeLogs',
            meta: {
                title: '合并日志'
            }
        },
        {
            path: 'news/examine',
            component: ReporterNews,
            name: 'ReporterNews',
            meta: {
                title: '文章补录审核'
            }
        },
        {
            path: 'groups-list',
            component: ReporterGroupsList,
            name: 'ReporterGroupsList',
            meta: {
                title: '重名详情',
                hidden: true
            }
        },
        {
            path: 'create',
            component: ReporterCreate,
            name: 'ReporterCreate',
            meta: {
                title: '记者创建',
                hidden: true
            }
        },
        {
            path: ':id',
            component: ReporterDetail,
            name: 'ReporterDetail',
            meta: {
                title: '记者详情',
                hidden: true
            }
        },
        {
            path: ':id/add-news',
            component: ReporterAddNews,
            name: 'ReporterAddNews',
            meta: {
                title: '补充文章',
                hidden: true
            }
        }
    ]
}
